<template lang="pug">
  SspLayout(area="core")
    .row
      .col-sm-6
        SspSaveForm(@onSubmit="save" :saving="saving" headerTitle="Order Details")
          .form-horizontal
            .form-group
              label.col-sm-4.control-label Order Name
              .col-sm-8
                input.form-control(v-model="description")
            .form-group
              label.col-sm-4.control-label Product
              .col-sm-8
                ProductSelect(v-model="productId")
            .form-group
              label.col-sm-4.control-label Schema
              .col-sm-8
                MetadataSchemaSelect(ref="metadataSchemaSelect" v-model="schemaId")

        SspSaveForm(@onSubmit="changeOwner" :saving="saving" :saveDisabled="!canChangeOwner" headerTitle="Change Owner" :hasCancel="false" v-visible-for="['ROLE_RUNAS']")
          .form-horizontal
            .form-group
              label.col-sm-4.control-label Organization
              .col-sm-8
                OrganizationSelect(v-model="selectedOrganizationId" ref="organizationSelect")
            .form-group
              label.col-sm-4.control-label User
              .col-sm-8
                UserSelectFromOrganization(:organizationId="selectedOrganizationId" v-model="selectedUserId" ref="userSelect")
            .form-group
              label.col-sm-4.control-label Group
              .col-sm-8
                GroupFromOrganizationSelect(:organizationId="selectedOrganizationId" v-model="selectedGroupId" ref="groupSelect")

      .col-sm-6
        .panel.panel-default
          .panel-heading
            .panel-title Actions
          .panel-body
            .container-fluid
              .row
                button.btn.btn-danger(@click="lockOrder" :disabled="locked === true")
                  i.fa(:class="locked ? '' : 'fa-lock'")
                  span.ml5 {{locked === true ? 'Order Is Locked' : 'Lock Order'}}
                button.btn.btn-primary.ml20(@click="makeSectioned" :disabled="sectioned")
                  i.fa.fa-film.pr5(v-if="!sectioned")
                  span {{ sectioned ? 'Already Sectioned' : 'Make Sectioned'}}

</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'
import ProductSelect from '@/components/ssp/ProductSelect'
import MetadataSchemaSelect from '@/components/ssp/MetadataSchemaSelect'
import OrganizationSelect from '@/components/ssp/OrganizationSelect'
import UserSelectFromOrganization from '@/components/ssp/UserSelectFromOrganization'
import GroupFromOrganizationSelect from '@/components/ssp/GroupFromOrganizationSelect'

export default {
  data: () => ({
    saving: false,
    selectedOrganizationId: null,
    selectedUserId: null,
    selectedGroupId: null,
    movedOrganizationObject: {},
    movedUserObject: {},
    loading: false,
    description: null,
    productId: null,
    schemaId: null,
    sectioned: false,
    locked: false,
  }),
  created() {
    this.getOrder()
  },
  methods: {
    changeOwner() {
      const req = {
        userId: this.selectedUserId,
        groupId: this.selectedGroupId,
        organizationId: this.selectedOrganizationId
      }

      Core.moveOrder(this.orderId, req)
        .then(() => {
          this.$router.push({ name: 'orders' })
        })
        .then(() => {
          const organizationName = this.$refs.organizationSelect.getSelectedOrganization().name
          const userName = this.$refs.userSelect.getSelectedUser().username
          miniToastr.success(`Order successfully moved to organization: ${organizationName}, with user: ${userName}`)
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    getOrder() {
      this.loading = true
      Core.getOrder(this.orderId)
        .then((resp) => {
          if (resp.data.description) {
            this.description = resp.data.description
          }
          if (resp.data.product) {
            this.productId = resp.data.product.id
          }
          if (resp.data.metadata) {
            this.schemaId = resp.data.metadata.schema.id
          }
          this.sectioned = resp.data.sectioned
          this.locked = resp.data.locked
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => { this.loading = false })
    },
    lockOrder() {
      this.$confirm({ text: 'Do you wish to lock this order? This action is not reversable!' })
        .then((conf) => {
          if (conf) {
            Core.lockOrder(this.orderId, { orderId: this.orderId })
              .then(() => {
                miniToastr.success('The order is now locked')
                this.getOrder()
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
    makeSectioned() {
      this.sectioned = true
      this.save()
    },
    save() {
      const req = this.createPayload()
      Core.updateOrder(this.orderId, req)
        .then(() => {
          miniToastr.success('The order has been updated')
          this.$router.push(`/core/orders/order/${this.orderId}`)
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    createPayload() {
      const req = {}

      req.sectioned = this.sectioned
      req.description = this.description
      req.productId = this.productId
      if (this.schemaId) {
        const selectedSchema = this.$refs.metadataSchemaSelect.getSelectedMetadataschema()
        req.metadataSchema = selectedSchema.name
      }
      req.orderId = this.orderId
      return req
    }
  },
  computed: {
    canChangeOwner() {
      return this.selectedOrganizationId && this.selectedUserId
    },
    orderId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    ProductSelect,
    MetadataSchemaSelect,
    OrganizationSelect,
    UserSelectFromOrganization,
    GroupFromOrganizationSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/OrderEdit.vue